// import { propertyTypes } from "../../data/dummyData";

// const Type = () => {
//   return (
//     <div className="p-3 mt-8 border dark:border-dark">
//       <h1 className="font-semibold">Property Type</h1>
//       {propertyTypes.map(({ id, name, number }) => (
//         <div key={id} className="mt-3 filter flex-center-between">
//           <div className="input-radio">
//             <input type="radio" name="type" id={name} />
//             <label htmlFor={name} className="capitalize">
//               {name}
//             </label>
//           </div>
//           <p>({number})</p>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Type;

import React, { useState } from "react";

const Type = ({ onTypeChange }) => {
  const propertyTypes = [
    { id: 1, name: "all" },
    { id: 2, name: "Premium Works" },
    { id: 3, name: "Steam" },
    { id: 4, name: "Sauna" },
    { id: 5, name: "Jacuzzi" },
    { id: 6, name: "Fountain" },
    { id: 7, name: "Playground Equipment" },
  ];

  const [activeType, setActiveType] = useState("all");

  const handleTypeClick = (name) => {
    setActiveType(name); // Set the active type
    onTypeChange(name);  // Notify parent component
  };

  return (
    <div className="p-3 mt-8 border dark:border-dark">
      <h1 className="font-semibold">Premium work</h1>
      {propertyTypes.map(({ id, name }) => (
        <div
          key={id}
          className={`mt-3 filter flex-center-between ${
            activeType === name ? "bg-gray-100 dark:bg-gray-800" : ""
          }`}
        >
          <div className="input-radio">
            <input
              type="radio"
              name="type"
              id={name}
              checked={activeType === name}
              onChange={() => handleTypeClick(name)}
            />
            <label htmlFor={name} className="capitalize cursor-pointer">
              {name}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Type;

